import type { Socket } from 'socket.io-client'

/**
 * Получение инстанса io для использования в приложении
 */
export function useSocket(): Socket {
  return inject('io') ?? useNuxtApp().$io
}
